import { useState } from 'react';
import { Alert, Box, Button, TextField } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useSendVerificationTokenMutation } from '../../redux/Apis/Auth';
import { authErrorMessage } from '../../utils/authSession';
export default function VerifyEmail() {
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || '');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [resend, { isLoading }] = useSendVerificationTokenMutation();
  const submit = async (event) => {
    event.preventDefault();
    setError(''); setMessage('');
    try { await resend({ email: email.trim().toLowerCase() }).unwrap(); setMessage('Om kontot behöver verifieras får du en länk via e-post. Kontrollera även skräpposten.'); }
    catch (failure) { setError(authErrorMessage(failure)); }
  };
  return <Box sx={{ maxWidth: 500, mx: 'auto', my: 6, px: 2 }}>
    <h1>Verifiera din e-postadress</h1>
    <p>Ange din e-postadress för att begära en ny verifieringslänk.</p>
    <form onSubmit={submit}>
      <TextField fullWidth label="E-postadress" type="email" required autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} disabled={isLoading} />
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      {message && <Alert severity="success" sx={{ mt: 2 }}>{message}</Alert>}
      <Button type="submit" variant="contained" disabled={isLoading} sx={{ my: 2 }}>{isLoading ? 'Skickar…' : 'Skicka verifieringslänk'}</Button>
    </form><Link to="/auth/login">Till inloggningen</Link>
  </Box>;
}
